export default __webpack_public_path__ + "static/media/audioIcon.6c646131.svg";